import Icon from "core/assets/icons";
import ArrowRight from "core/assets/icons/menu/arrow_r.svg";
import CDialog from "core/components/CDialog";
import { CInputControl } from "core/components/form-controls";
import PageHeader from "core/components/Header/PageHeader";
import useDebounce from "core/hooks/useDebounce";
import { useFormikCustom } from "core/hooks/useFormikCustom";
import { _t } from "core/language";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import { RouterName } from "core/router";
import { getFieldInputProps } from "core/utils/form";
import LoadingAI from "modules/AiChef/components/Loading";
import { useRecipe } from "modules/Ingredients/hooks/recipe";
import { useCallback, useEffect, useState } from "react";
import { useGoToRecipeDetail, useSearchRecipes } from "../hooks/recipe";
import Skeleton from "react-loading-skeleton";
import { useSearchParams } from "react-router-dom";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
// import { useUser } from "modules/Auth/hooks";

const SearchRecipeNative = () => {
  const { resetRecipes, setKeyword, goToRecipeSuggession } = useRecipe();
  const appLang = (window as any)._APP_LANG;
  console.log(appLang, 'appLang');
  
  const navigate = useCustomNavigate();
  const {
    requestSearchAi,
    searchError,
    searchData,
    requestRecipeSuggestionRequestByKeyword,
    cancelRequest,
    recipeRequestId,
    recipeRequestError,
    recipeRequestLoading,
    resetSearch,
  } = useSearchRecipes();
  const [searchParams] = useSearchParams();
  const goToDetail = useGoToRecipeDetail(RouterName.INGREDIENT_RECIPE_DETAIL);
  const [searchTerm, setSearchTerm] = useState(searchParams.get("keyword") || '');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingAi, setLoadingAi] = useState(false);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const [searchResults, setSearchResults] = useState([]);

  const formik = useFormikCustom({
    initialValues: {
      name: "",
    },
    onSubmit() {},
  });

  useEffect(() => {
    if (searchTerm !== "") {
      setLoading(true);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (formik.values.name) {
      setSearchTerm(formik.values.name);
    } else {
      setSearchTerm("");
      setSearchResults([]);
    }
  }, [formik.values.name]);

  const requestRecipeKeyword = useCallback(() => {
    if ((window as any).webviewRequestRecipeKeyword) {
      if (debouncedSearchTerm) {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("keyword", debouncedSearchTerm);
        // setSearchParams(newParams, { replace: true }); 
        // console.log('newParams',newParams.get('keyword'));
        navigate(location.pathname + "?keyword=" + newParams.get('keyword'), {
          replace: true,
        });
        // navigate(location.pathname + "?" + searchParams.toString());
        (window as any).webviewRequestRecipeKeyword(debouncedSearchTerm);
      }
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    if (searchParams.get("keyword")) {
      formik.setFieldValue("name", searchParams.get("keyword"));
    }
  }, [searchParams.get("keyword")]);

  useEffect(() => {
    requestRecipeKeyword();
  }, [requestRecipeKeyword]);

  useEffect(() => {
    if (searchData.length > 0) {
      goToDetail(searchData[0]);
      resetSearch();
    }
  }, [searchData]);

  useEffect(() => {
    if (searchError) {
      if (searchError.status === 400) {
        console.log("searchError", searchError);
        setOpen(true);
      }
    }
  }, [searchError]);

  useEffect(() => {
    (window as any).nativeResponseRecipeList = (data: any) => {
      if (typeof data === "string") {
        data = JSON.parse(data);
      }
      console.log("nativeResponseRecipeList", data);
      
      const _data = data.map((item: any) => {
        return {
          ...item,
          name: item.dish_name,
        };
      });
      setLoading(false);
      setSearchResults(_data);
    };

    return () => {
      delete (window as any).nativeResponseRecipeList;
    };
  }, [formik.values.name]);

  useEffect(() => {
    // cancel request
    return () => {
      cancelRequest();
    }
  }, [])

  const handleSearch = () => {
    setLoading(false);
    if (formik.values.name) {
      setKeyword(formik.values.name);
      requestRecipeSuggestionRequestByKeyword(formik.values.name);
    }
  };

  useEffect(() => {
    if (recipeRequestId) {
      goToRecipeSuggession([], false);
    }
  }, [recipeRequestId]);

  useEffect(() => {
    if (recipeRequestError) {
      setOpen(true);
    }
  }, [recipeRequestError]);

  const handleDetail = (item: any) => {
    if (item.name) {
      setLoadingAi(true);
      requestSearchAi({ keyword: item.name });
    }
  };

  const getRandomWidth = () => `${Math.floor(Math.random() * 31) + 40}%`;
  const itemLoading = [1, 2, 3, 4, 5];

  return (
    <AppLayout>
      <PageHeader title={_t("recipe.search.title")} sticky 
        handleGoBack={() => {
          navigate(RouterName.MAIN)
        }}
      />
      <div className="relative w-full max-w-md mx-auto   p-4">
        <div className="relative">
          <CInputControl
            className=""
            maxLength={200}
            placeholder={_t("recipe.search.placeholder")}
            classNameIcon="!w-[18px] !h-[18px]"
            classNameInput={`!text-[14px] ${formik.values.name ? "!border-[#FF6741]" : ""}`}
            {...getFieldInputProps(formik, "name")}
            onEnter={handleSearch}
          />
          <img
            src={Icon.RecipeSearch}
            alt=""
            className="absolute right-[9px] top-[10px]"
            onClick={handleSearch}
          />
          {searchResults.length > 0 && !loading && (
            <ul className="w-full bg-white absolute top-[50px] left-0 max-h-[400px] overflow-y-auto">
              {searchResults.map((item: any, index) => (
                <li
                  key={index}
                  className="border-b border-gray-300 p-2 text-sm font-medium flex justify-between items-center"
                  onClick={() => handleDetail(item)}
                >
                  <span>{item.name}</span>
                  <img src={ArrowRight} alt="" />
                </li>
              ))}
            </ul>
          )}
          {!searchResults && !loading && (
            <div className="w-full bg-white absolute top-[50px] left-0">
              <p className="p-2 text-gray-500">{_t("recipe.noData")}</p>
            </div>
          )}
          {loading && searchResults.length === 0 && searchTerm !== "" && (
            <ul className="w-full bg-white absolute top-[50px] left-0">
              {itemLoading.map((item) => (
                <li
                  key={item}
                  className="border-b border-gray-300 p-2 font-medium"
                >
                  <Skeleton count={1} width={getRandomWidth()} />
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      {(loadingAi || recipeRequestLoading) && <LoadingAI />}

      <CDialog
        open={open}
        closeModal={() => {
          setOpen(false);
          setLoadingAi(false);
          cancelRequest();
        }}
        handleSubmit={() => {
          setOpen(false);
          setLoadingAi(false);
          cancelRequest();
        }}
        classNamechildren="px-[8px]"
        submitText={_t("recipe.recipe_close")}
        hideCancel
        disableCloseOnBackDrop
      >
        <div className="w-full text-center">
          <p
            className="text-sm tracking-tighter"
            dangerouslySetInnerHTML={{
              __html: searchError?.response?.data?.msg || recipeRequestError?.msg || "Error",
            }}
          />
        </div>
      </CDialog>
      <BottomNavigation onNavigateChange={resetRecipes} activeIndex={2} />
    </AppLayout>
  );
};

export default SearchRecipeNative;
